// src/theme/components/heading.js
// Faz 2 · Mevcut size'lar (4xl-xs) AYNEN korundu.
// Yeni variant'lar (display1, display2, headline, title, subtitle, sectionHeading,
// numericLarge) eklendi · Material 3 / Apple HIG hibrit hiyerarsi.

const Heading = {
  baseStyle: {
    fontFamily: 'heading',
    fontWeight: 'bold',
    color: 'textPrimary',
  },

  // Mevcut size scale · geriye uyumluluk korunur.
  sizes: {
    '4xl': {
      fontSize: { base: '2rem', md: '2.25rem' },
      lineHeight: { base: '1.2', md: '1.2' },
    },
    '3xl': {
      fontSize: { base: '1.625rem', md: '1.875rem' },
      lineHeight: { base: '1.2', md: '1.2' },
    },
    '2xl': {
      fontSize: { base: '1.375rem', md: '1.5rem' },
      lineHeight: { base: '1.3', md: '1.3' },
    },
    'xl': {
      fontSize: { base: '1.1875rem', md: '1.25rem' },
      lineHeight: { base: '1.3', md: '1.3' },
    },
    'lg': {
      fontSize: { base: '1.0625rem', md: '1.125rem' },
      lineHeight: { base: '1.4', md: '1.4' },
    },
    'md': {
      fontSize: { base: '0.9375rem', md: '1rem' },
      lineHeight: { base: '1.4', md: '1.4' },
    },
    'sm': {
      fontSize: { base: '0.8125rem', md: '0.875rem' },
      lineHeight: { base: '1.4', md: '1.4' },
    },
    'xs': {
      fontSize: { base: '0.6875rem', md: '0.75rem' },
      lineHeight: { base: '1.4', md: '1.4' },
    },
  },

  // ====================================================================
  // Faz 2 · Yeni semantic variant'lar.
  // ====================================================================
  variants: {
    // ===== DISPLAY (en buyuk · landing hero) =====
    'display1': {
      fontSize: { base: 'display.lg', md: 'display.xl', lg: 'display.2xl' },
      lineHeight: 'display',
      fontWeight: 'extrabold',
      letterSpacing: 'display',
      fontFamily: 'display',
    },
    'display2': {
      fontSize: { base: 'display.md', md: 'display.lg', lg: 'display.xl' },
      lineHeight: 'display',
      fontWeight: 'extrabold',
      letterSpacing: 'display',
      fontFamily: 'display',
    },

    // ===== HEADLINE (sayfa basliklari) =====
    'headline': {
      fontSize: { base: '3xl', md: '4xl' },
      lineHeight: 'heading',
      fontWeight: 'bold',
      letterSpacing: 'heading',
    },

    // ===== TITLE (kart basliklari, modal title) =====
    'title': {
      fontSize: { base: '2xl', md: '3xl' },
      lineHeight: 'heading',
      fontWeight: 'bold',
      letterSpacing: 'heading',
    },

    // ===== SUBTITLE =====
    'subtitle': {
      fontSize: { base: 'xl', md: '2xl' },
      lineHeight: 'subheading',
      fontWeight: 'semibold',
      letterSpacing: 'subheading',
    },

    // ===== SECTION (form/panel basliklari) =====
    'sectionHeading': {
      fontSize: { base: 'lg', md: 'xl' },
      lineHeight: 'subheading',
      fontWeight: 'semibold',
      letterSpacing: 'subheading',
    },

    // ===== READING (.ders-container H1 esdegeri · serif tema) =====
    'reading': {
      fontSize: { base: '2xl', md: '3xl', lg: '4xl' },
      lineHeight: 'heading',
      fontWeight: 'bold',
      letterSpacing: 'heading',
      fontFamily: 'reading',
      color: 'reading.heading',
    },

    // ===== NUMERIC LARGE (dashboard buyuk sayi gostergeleri) =====
    'numericLarge': {
      fontSize: { base: '3xl', md: '4xl', lg: 'display.sm' },
      lineHeight: 'heading',
      fontWeight: 'bold',
      fontFamily: 'numeric',
      fontFeatureSettings: '"tnum", "lnum"',
      letterSpacing: 'heading',
    },

    // ===== ACCENT (gradient text · landing/marketing) =====
    'accent': {
      fontSize: { base: '3xl', md: '4xl' },
      lineHeight: 'heading',
      fontWeight: 'extrabold',
      letterSpacing: 'heading',
      bgGradient: 'linear(to-r, brand.500, indigo.500)',
      bgClip: 'text',
      // Fallback (eski tarayicilar)
      color: 'transparent',
    },
  },

  defaultProps: {
    size: 'xl',
  },
};

export default Heading;
